<template>
<div>
  <div v-if="!emailInitiated">
    <p class="error">&nbsp; {{ error }}</p>
    <input v-model="email"
    class="input"
    type="text"
    placeholder="email">
    <button
      type="button"
      class="button"
      @click="startPasswordLess">
      Login
    </button>
  </div>
  <div v-else>
    <p>Enter verification code sent to {{ email }}:</p>
    <p v-if="error" class="error">&nbsp; {{ error }}</p>
    <input v-model="code"
      class="input"
      type="password"
      placeholder="code">
      <button
        type="button"
        class="button"
        @click="verifyPasswordLess">
        Verify
      </button>
  </div>
</div>
</template>

<script>
export default {
  name: 'PasswordLess',
  data() {
    return {
      emailInitiated: false,
      email: '',
      code: '',
      error: '',
    };
  },
  methods: {
    async startPasswordLess() {
      await this.$auth.passwordlessStart({
        connection: 'email',
        send: 'code',
        email: this.email,
      }, (err) => {
        if (err === null) {
          this.emailInitiated = true;
          this.error = null;
        } else {
          this.error = 'Error initiating login';
        }
      });
    },
    async verifyPasswordLess() {
      await this.$auth.passwordlessLogin({
        connection: 'email',
        email: this.email,
        verificationCode: this.code,
      }, (err) => {
        if (err !== null) {
          this.error = 'Error validating code';
        } else {
          this.error = null;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
p {
  font-size: .8rem;
  margin-bottom: 1rem;
  text-align: center;
}

p.error {
  color: $attention;
}

button {
  margin: 1rem 0;
  width: 100%;
}

input {
  text-align: center;
}

</style>
